import TitleHeader from '../../../components/MasterComponent/TitleHeader/TitleHeader';
import { SelectedAccount } from '../../../components/SelectAccount/SelectAccount';
import { CLOUD_PROVIDER_SERVICES } from '../../../utils/constants';
import { useFetchData } from '../../../hooks/useFetchData';
import { accountState } from '../../../store';
import React, { useRef, useState } from 'react';
import '../cost-breakup.css';
import { config } from '../config';
import GraphContainer from './GraphContainer';
import ServiceTypeTransfer from './ServiceTypeTransfer';
import DailyUsageBreakup from './DailyUsageBreakup';
import TopTenResources from './TopTenResources';
import SummaryGridSkeleton from '../../../components/CostBreakup/SummaryGridSkeleton';
import SummaryGrid from '../../../components/CostBreakup/SummaryGrid';
import { ReactComponent as RecommendationIconImg } from '../../../assets/images/recommendationIcon.svg';
import { useSelector } from 'react-redux';
import Header from '../../../components/CostBreakup/Header';

const DataTransfer: React.FC<any> = () => {

  interface SummaryItem {
    title: string;
    value: string;
    trend?: 'up' | 'down' | 'neutral';
    trendValue?: string;
    trendAmount?: string;
    description?: string;
    icon?: React.ReactNode;
    buttonLabel?: string;       // Button text
    onButtonClick?: () => void; // Optional click handler
  }

  const selectedAccountInfo = useSelector(accountState);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [activeView, setActiveView] = useState<'table' | 'barchart' | 'linechart'>('barchart');
  const dummyAccountData = {
    'Account 276505133448': {
      'Apr-2025': { cost: 280 },
      'May-2025': { cost: 370 },
      'Jun-2025': { cost: 340 },
      totalCost: 990
    }
  };

  const dummyTypeData = {
    'Internet (Out)': {
      'Apr-2025': { cost: 150 },
      'May-2025': { cost: 200 },
      'Jun-2025': { cost: 200 },
      totalCost: 550
    },
    'Inter AZ': {
      'Apr-2025': { cost: 100 },
      'May-2025': { cost: 110 },
      'Jun-2025': { cost: 90 },
      totalCost: 300
    },
    'Region to Region': {
      'Apr-2025': { cost: 40 },
      'May-2025': { cost: 60 },
      'Jun-2025': { cost: 50 },
      totalCost: 150
    }
  };

  const summaryCardData: SummaryItem[] = [
    {
      title: 'Mar 2025',
      description: 'Cost',
      value: '290',
      trend: 'down',
      trendValue: '31%',
      trendAmount: '69.00',
    },
    {
      title: 'April 2025',
      description: 'Cost',
      value: '290',
      trend: 'up',
      trendValue: '31%',
      trendAmount: '69.00',
    },
    {
      title: 'May 2025',
      description: 'Cost',
      value: '290',
      trend: 'down',
      trendValue: '31%',
      trendAmount: '69.00',
    },
    {
      title: 'You can reduce data transfer cost',
      description: 'By using CloudFront',
      value: '21.27',
      icon: <RecommendationIconImg width={73} height={73} />,
      onButtonClick: () => {
        console.log('Details Clicked');
      },
      buttonLabel: 'View Details'
    },
  ];

  const dailyUsageData = {
  'Elastic Compute Cloud': {
    '1-Jun': { cost: 420 },
    '2-Jun': { cost: 450 },
    '3-Jun': { cost: 470 },
    '4-Jun': { cost: 480 },
    '5-Jun': { cost: 500 },
    '6-Jun': { cost: 520 },
    '7-Jun': { cost: 540 },
    '8-Jun': { cost: 530 },
    '9-Jun': { cost: 560 },
    '10-Jun': { cost: 590 },
    '11-Jun': { cost: 620 },
    '12-Jun': { cost: 640 },
    '13-Jun': { cost: 660 },
    '14-Jun': { cost: 540 },
    '15-Jun': { cost: 500 },
    '16-Jun': { cost: 480 },
    '17-Jun': { cost: 520 },
    '18-Jun': { cost: 500 },
    '19-Jun': { cost: 480 },
    '20-Jun': { cost: 460 },
  },
  'Elastic Load Balancing': {
    '1-Jun': { cost: 60 },
    '2-Jun': { cost: 65 },
    '3-Jun': { cost: 55 },
    '4-Jun': { cost: 50 },
    '5-Jun': { cost: 55 },
    '6-Jun': { cost: 60 },
    '7-Jun': { cost: 62 },
    '8-Jun': { cost: 58 },
    '9-Jun': { cost: 65 },
    '10-Jun': { cost: 68 },
    '11-Jun': { cost: 70 },
    '12-Jun': { cost: 72 },
    '13-Jun': { cost: 74 },
    '14-Jun': { cost: 58 },
    '15-Jun': { cost: 54 },
    '16-Jun': { cost: 52 },
    '17-Jun': { cost: 56 },
    '18-Jun': { cost: 55 },
    '19-Jun': { cost: 52 },
    '20-Jun': { cost: 50 },
  },
  'Simple Storage Service': {
    '1-Jun': { cost: 12 },
    '2-Jun': { cost: 15 },
    '3-Jun': { cost: 14 },
    '4-Jun': { cost: 13 },
    '5-Jun': { cost: 15 },
    '6-Jun': { cost: 16 },
    '7-Jun': { cost: 18 },
    '8-Jun': { cost: 17 },
    '9-Jun': { cost: 19 },
    '10-Jun': { cost: 20 },
    '11-Jun': { cost: 22 },
    '12-Jun': { cost: 21 },
    '13-Jun': { cost: 23 },
    '14-Jun': { cost: 17 },
    '15-Jun': { cost: 16 },
    '16-Jun': { cost: 15 },
    '17-Jun': { cost: 16 },
    '18-Jun': { cost: 15 },
    '19-Jun': { cost: 14 },
    '20-Jun': { cost: 13 },
  },
  'Relational Database Service': {
    '1-Jun': { cost: 5 },
    '2-Jun': { cost: 6 },
    '3-Jun': { cost: 5 },
    '4-Jun': { cost: 5 },
    '5-Jun': { cost: 6 },
    '6-Jun': { cost: 7 },
    '7-Jun': { cost: 7 },
    '8-Jun': { cost: 6 },
    '9-Jun': { cost: 7 },
    '10-Jun': { cost: 8 },
    '11-Jun': { cost: 9 },
    '12-Jun': { cost: 9 },
    '13-Jun': { cost: 10 },
    '14-Jun': { cost: 7 },
    '15-Jun': { cost: 6 },
    '16-Jun': { cost: 5 },
    '17-Jun': { cost: 6 },
    '18-Jun': { cost: 6 },
    '19-Jun': { cost: 5 },
    '20-Jun': { cost: 5 },
  },
  'Simple Email Service': {
    '1-Jun': { cost: 3 },
    '2-Jun': { cost: 3 },
    '3-Jun': { cost: 4 },
    '4-Jun': { cost: 3 },
    '5-Jun': { cost: 3 },
    '6-Jun': { cost: 3 },
    '7-Jun': { cost: 4 },
    '8-Jun': { cost: 4 },
    '9-Jun': { cost: 4 },
    '10-Jun': { cost: 5 },
    '11-Jun': { cost: 5 },
    '12-Jun': { cost: 5 },
    '13-Jun': { cost: 5 },
    '14-Jun': { cost: 4 },
    '15-Jun': { cost: 3 },
    '16-Jun': { cost: 3 },
    '17-Jun': { cost: 3 },
    '18-Jun': { cost: 3 },
    '19-Jun': { cost: 3 },
    '20-Jun': { cost: 3 },
  },
  'Others': {
    '1-Jun': { cost: 2 },
    '2-Jun': { cost: 2 },
    '3-Jun': { cost: 2 },
    '4-Jun': { cost: 2 },
    '5-Jun': { cost: 2 },
    '6-Jun': { cost: 2 },
    '7-Jun': { cost: 2 },
    '8-Jun': { cost: 2 },
    '9-Jun': { cost: 2 },
    '10-Jun': { cost: 2 },
    '11-Jun': { cost: 2 },
    '12-Jun': { cost: 2 },
    '13-Jun': { cost: 2 },
    '14-Jun': { cost: 2 },
    '15-Jun': { cost: 2 },
    '16-Jun': { cost: 2 },
    '17-Jun': { cost: 2 },
    '18-Jun': { cost: 2 },
    '19-Jun': { cost: 2 },
    '20-Jun': { cost: 2 },
  }
  };

  const summaryData = {
    totalCost: 205.29,
    interAZ: { quantity: 8631.45, cost: 86.30 },
    internetOut: { quantity: 883.79, cost: 76.56 },
    regionToRegion: { quantity: 2121.30, cost: 42.43 },
  };
  const [selectedAccountId, setSelectedAccountId] = React.useState<any>(
    selectedAccountInfo.selectedAccountId
  );
  const reqBodyRef = useRef({});
  // const { fetch, data, loader: isSubmitting } = useFetchData({
  //   fetchData: () => config.getDataTransferReport(reqBodyRef.current),

  //   fetchOnMount: true,
  // });
  //account selection section
  const onAccountChange = (data: any) => {
    if (data.cloudType === CLOUD_PROVIDER_SERVICES.AWS)
      setSelectedAccountId(data.accountId);
    // else if (data.cloudType === CLOUD_PROVIDER_SERVICES.AZURE) {
    //   if (data.subscriptionName) {
    //     setSelectedSubscriptionId(data.subscriptionId);
    //   } else if (data.accountId) {
    //     setSelectedAccountId(data.accountId);
    //     setSelectedSubscriptionId(ALL_VALUE);
    //   }
    // }
    setTimeout(() => {
      //fetch();
    }, 0);
  };
  
  return (
    <div className='app-container'>
      <TitleHeader
        extraContent={<SelectedAccount onAccountChange={onAccountChange} />}
      >
        Data Transfer
      </TitleHeader>
       <div className="gray-container">
        <Header showMonthFilter />
        <div className="card-wrapper first-block">
          <div className="cards-container">
            {isSummaryLoading ? (
              <SummaryGridSkeleton />
            ) : (
              <SummaryGrid summaryData={summaryCardData} />
            )}
          </div>
        </div>
        <GraphContainer dummyAccountData={dummyAccountData} dummyTypeData={dummyTypeData} isSubmitting={false} />
        <ServiceTypeTransfer data={{}} />
        <DailyUsageBreakup dailyUsageData={dailyUsageData} isSubmitting={false}  activeView={activeView} onViewChange={setActiveView}/>
        <TopTenResources  data={summaryData} />
      </div>
    </div>
  );
};

export default DataTransfer;
